import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'react-toastify/dist/ReactToastify.css'
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <div className='container'>
    <App />
    </div>
);

